export enum Entity {
  ADMIN = 'admin',
  USERS = 'users',
  BINNING = 'binning',
  BINS = 'bins',
  BLENDING = 'blending',
  COMPANIES = 'companies',
  CONSISTENCY = 'consistency',
  DELIVERY = 'delivery',
  NIR = 'nir',
  SILOS = 'silos',
  SIMILARITY = 'similarity',
  WHEAT_CODE = 'wheat_code',
  PRODUCT = 'blending_spec(product)',
  PRODUCT_FLOUR = 'flour_spec',
  PRODUCT_BAKERS = 'baker_flour_spec',
  BAKER_ANALYTICS = 'baker_flour_deliveries', // BAKER MODULE - Product delivery list page
  FLOURS = 'flours',
  FLOUR_SPEC = 'flour_spec',
  DATA = 'data',
}

export enum CrudAction {
  CREATE = 'create',
  GET = 'get',
  UPDATE = 'update',
  DELETE = 'delete',
}

export type BlendingGranularAction = 'accept'
export type DeliveryGranularAction =
  | 'create_group'
  | 'update_group'
  | 'get_stored'
  | 'allocate_green'
  | 'allocate_yellow'
  | 'allocate_red'
export type SilosGranularAction = 'link' | 'unlink'
export type WheatCodeGranularAction = 'cost_read' | 'cost_update'

export type Action =
  | CrudAction
  | BlendingGranularAction
  | DeliveryGranularAction
  | SilosGranularAction
  | WheatCodeGranularAction

export type EntityActionMap = {
  [Entity.ADMIN]: CrudAction
  [Entity.USERS]: CrudAction
  [Entity.BINNING]: CrudAction
  [Entity.BINS]: CrudAction
  [Entity.BLENDING]: CrudAction | BlendingGranularAction
  [Entity.COMPANIES]: CrudAction
  [Entity.CONSISTENCY]: CrudAction
  [Entity.DELIVERY]: CrudAction | DeliveryGranularAction
  [Entity.NIR]: CrudAction
  [Entity.SILOS]: CrudAction | SilosGranularAction
  [Entity.SIMILARITY]: CrudAction
  [Entity.WHEAT_CODE]: CrudAction | WheatCodeGranularAction
  [Entity.FLOURS]: CrudAction
  [Entity.FLOUR_SPEC]: CrudAction
  [Entity.DATA]: CrudAction
  [Entity.PRODUCT]: CrudAction
  [Entity.PRODUCT_FLOUR]: CrudAction
  [Entity.PRODUCT_BAKERS]: CrudAction
  [Entity.BAKER_ANALYTICS]: CrudAction
}

export type Permissions = {
  [E in Entity]?: {
    [A in EntityActionMap[E]]?: boolean
  }
}

export type PermissionType = {
  entity: Entity
  action?: Action | Action[]
}

export interface CompanyRoles {
  company_id: number
  role_id: number
  company_name?: string
  role_name?: string
}
